import { Divider, Radio } from "antd";
import React, { useState } from "react";
import { AiOutlineLeft } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import "./styles.css";

function ResgatarBonus() {
  const navigate = useNavigate();

  function handleConfirmar() {
    if (radioValue === "dinheiro") {
      navigate("/bonusIndicacao?bonus=dinheiro");
    } else if (radioValue === "pontos") {
      navigate("/bonusIndicacao?bonus=pontos");
    } else {
      navigate("/bonusIndicacao");
    }
  }

  const [radioValue, setRadioValue] = useState("dinheiro");
  return (
    <div className="container">
      <label className="title">
        Bônus disponível <br /> para resgatar.
      </label>
      <div className="subtitle">Selecione a recompensa que deseja:</div>
      <div className="options">
        <Radio.Group
          onChange={(e) => setRadioValue(e.target.value)}
          value={radioValue}
        >
          <Radio value="dinheiro">
            <span className="">R$ 10,00 na sua Rede Frota Conta Digital</span>
          </Radio>
          <Divider />
          <Radio value="pontos">
            <span>600 pontos no Pegapontos</span>
          </Radio>
          <Divider />
        </Radio.Group>
      </div>
      <button className="btn-confirmar" onClick={handleConfirmar}>
        CONFIRMAR
      </button>
      <button className="btn-voltar" onClick={() => navigate(-1)}>
        <AiOutlineLeft /> Anterior
      </button>
    </div>
  );
}

export default ResgatarBonus;
